import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDispatch } from 'react-redux';

import { useNavigationTracker } from 'app/hooks';
import { navbarCloseMobile } from 'app/store/fuse/navbarSlice';
import navigateToConnectV1 from 'app/utils/navigateToConnectV1';
import config from '@/config.json';

import type { SidebarItemClickHandler } from '../types';

import useNewlyIncludedPages from './useNewlyIncludedPages';

export default function useSidebarItemClick(): SidebarItemClickHandler {
  const trackNavigation = useNavigationTracker();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
  const dispatch = useDispatch();
  const { markSeen } = useNewlyIncludedPages();

  return (item, event) => {
    trackNavigation(item);
    // Clicking a page clears its green dot; connect-v1 pages (Orders) can't clear it once opened.
    markSeen(item.id);

    // connect-v1 links need a one-time access grant before the cross-app hand-off,
    // so intercept them here rather than letting the anchor navigate straight there.
    if (item.url && item.url.startsWith(config.connectV1Url)) {
      if (event) event.preventDefault();
      navigateToConnectV1(item.url.slice(config.connectV1Url.length));
    }

    if (mdDown) {
      // The JS slice types every reducer as taking a payload; this one ignores it.
      dispatch(navbarCloseMobile(undefined));
    }
  };
}
